import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './OrganizationContactPerson.html?raw';

import _uiFrameMixin from '../../../../moreCore/UI/Container/uiFrame';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import ContactPersonForm from '../ContactPersonForm';
import { AddressWizardTypes as Types } from "../../AddressWizardTypes";
import NewPerson from '../../QuickNew/NewPerson';

class OrganizationContactPerson extends compose(_uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private organizationEntity: Types.AddressEntity;

    private addressHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private contactPersonForm: MdsLax<InstanceType<typeof ContactPersonForm>>;
    private formSection: HTMLElement;

    constructor(organization: Types.AddressEntity) {
        super(...(arguments as unknown as []));
        this.organizationEntity = organization;
    }

    isValid(): boolean {

        if (!this.addressHintbox.isValid) return false;

        return true;
    }

    private _onChange_PersonValue() {

        let person = this.addressHintbox.getValue("entity");

        this.disableNode(this.formSection, !person);
        if (!person) {
            //this.addressHintbox.disableInlineButton("viewAddressButton");
            return
        };

        //this.addressHintbox.disableInlineButton("viewAddressButton", false);
        this.contactPersonForm.setup(person.ID);

        this.enableButton("save", this.isValid());
    }

    private _onClickOpenSED(mode: string, e: MouseEvent) {
        switch (mode) {
            case "selectPerson":
                this.openSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDResponse), null, { organizationID: this.organizationEntity.ID });
                break;
        }
    }
    private _onSEDResponse(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<any>>) {
        switch (mode) {
            case "selectPerson":
                if (items && items.length > 0) {
                    this.addressHintbox.setValue(items[0].entry.data);
                }
                break;
        }
    }
    private _onClick_SaveBtn() {
        this.StandbyStart();

        let data = this.contactPersonForm.getValues();
        data.ref_person = this.addressHintbox.getValue();

        console.debug("_onClick_SaveBtn - DATA", data);
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_ContactPersonForm_New_SaveData",
            data,
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._showErrorMessage)
        );
    }
    private _onSaveResponse(response: Types.OrganisationContactPersonEntity) {
        this.StandbyStop();

        this.showToast(this.translate("General_Notification_SaveSuccess"), "fas fa-check");

        this.emit("saved", response);
        this.close();
    }

    private _onClickViewAddressBtn() {

        alert("_onClickViewAddressBtn - NOT IMPLEMENTED YET!");
        //let view = new AddressView();
        //let entityID;
        //let gDisp;

        //view.showAsDlg(entityID, gDisp, this.getTabContainerName());

    //    view.on("change", lang.hitch(this, this.loadEntity, this.entityId));
    //    view.on("deleted", lang.hitch(this, this.close));
    }

    private _onClickNewPersonBtn() {

        let quickNew = new NewPerson();
        quickNew.show("dlg");
        quickNew.on("NewPerson_Ready", lang.hitch(this, this._onNewPersonReady));
    }

    private _onNewPersonReady(person: { ID: string, gDisp_1: string }) {
        this.hourGlassStart(this.addressHintbox);

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_ContactPersonForm_CanAddPerson",
            {
                personId: person.ID,
                organizationId: this.organizationEntity.ID
            },
            lang.hitch(this, this._onCanAddPersonResponse, person),
            lang.hitch(this, this._showErrorMessage)

        );
    }
    private _onCanAddPersonResponse(person: { ID: string, gDisp_1: string }, response: { can_add_person: boolean }) {
        this.hourGlassEnd(this.addressHintbox);

        if (response.can_add_person) this.addressHintbox.setValue(person);
        else this._showErrorMessage(`${person.gDisp_1} - ${this.translate("AddressWizard_ContactPerson_CantAddPerson")}`);
    }

    private _showErrorMessage(err?: more.requestErrorMessage | string) {
        let msg;

        if (typeof err == "string") msg = err;
        else msg = err ? err.Message : "...error occured";

        this.showToast(msg, "fas fa-exclamation-triangle");
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.createDefaultButton("save", lang.hitch(this, this._onClick_SaveBtn), false);

        this.SEDconfigCallfunction = "Webtool_API_AddressWizard__SED_GetConfig";
        this.disableNode(this.formSection);

        this.addressHintbox.addAdditionalRequestParameter("organizationID", this.organizationEntity.ID);

        this.addressHintbox.addInlineButton(lang.hitch(this, this._onClickNewPersonBtn), "newPersonButton", "fas fa-plus-circle", null, { content: this.translate("AddressWizard_Tooltip_AddNewPerson"), delayMS: 250 });
        //this.addressHintbox.addInlineButton(lang.hitch(this, this._onClickViewAddressBtn), "viewAddressButton", "fas fa-address-card", null, { content: this.translate("AddressWizard_Tooltip_ShowAddressInfo"), delayMS: 250 });
        //this.addressHintbox.disableInlineButton("viewAddressButton");
        this.addressHintbox.addInlineButton(lang.hitch(this, this._onClickOpenSED, "selectPerson"), "sedButton", "fas fa-share-square", null, { content: this.translate("AddressWizard_Tooltip_OpenSelectionWindow"), delayMS: 250 } );

        this.contactPersonForm = new ContactPersonForm();
        this.contactPersonForm.setDefaultOrganization(this.organizationEntity);
        this.contactPersonForm.placeAt(this.formSection);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OrganizationContactPerson);